module.exports = function ($, M) {
  'use strict';

  var tracking = require('apps/utils')(M);
  var element = 'purchase';

  $(document).ready(function () {
    if (tracking.checkTracking(element)) {
      var action = tracking.getTrackingAction(element);
      tracking.formatTracking(element, 'order_id');

      analytics.track(action, M.tracking[element]);

      if (isLast(action)) {
        tracking.removeTrackingId('order_id');
      }
    }
  });

  function isLast(action) {
    var lastActions = ['Failed', 'Completed'];
    var last = false;
    $.each(lastActions, function (index, value) {
      if (action.indexOf(value) > -1) {
        last = true;
        return false;
      }
    });

    return last;
  }
};
